import {
  withTranslation,
} from 'react-i18next';

import BannersSectionView from './BannersSectionView';

const TranslatedComponent = withTranslation()(BannersSectionView);

const Component = TranslatedComponent;

export default Component;
